import { CloseOutlined } from "@ant-design/icons";
import { Dialog, DialogContent } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import useLandingAuthApi from "../../services/api/useLandingAuthApi";
import "../css/SearchAirportDialog.css";
import Loader from "./Loader";

const SearchAirportDialog = ({
  open,
  onClose,
  airportData,
  onSelectAirport,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedAirport, setSearchedAirport] = useState(airportData);
  const { searchAirport } = useLandingAuthApi();
  const [searchTimeout, setSearchTimeout] = useState(null);

  const searchAirportMutation = useMutation({
    mutationFn: ({ data }) =>
      searchAirport({
        searchTerm: data,
        limit: 100,
      }),
    onSuccess: (response, variables) => {
      // Only update results if the search term matches the current input
      if (variables.data === searchText) {
        const airportData = response?.data || response || [];
        setSearchedAirport(airportData);
      }
    },
  });

  useEffect(() => {
    setSearchText("");
    setSearchedAirport(airportData);

    // Clear any pending search timeout when dialog opens/closes
    if (searchTimeout) {
      clearTimeout(searchTimeout);
      setSearchTimeout(null);
    }
  }, [open, airportData]);

  const handleAirportSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);

    // Clear any existing timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    if (text.length > 2) {
      // Set a new timeout to debounce the search
      const timeout = setTimeout(() => {
        searchAirportMutation.mutate({
          data: text,
        });
      }, 300); // 300ms delay
      setSearchTimeout(timeout);
    } else {
      setSearchedAirport(airportData);
    }
  };

  const handleSelectAirport = (airport) => {
    onSelectAirport(airport);
    onClose();
  };

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "search-airport-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="search-airport-dialog-close"
          onClick={onClose}
        />
        <div className="search-airport-dialog-content">
          <div className="search-airport-dialog-title">Search Airport</div>
          <input
            placeholder="Search Airport"
            value={searchText}
            onChange={handleAirportSearchChange}
          ></input>
          <div className="search-airport-dialog-list">
            {searchAirportMutation?.isPending ? (
              <Loader />
            ) : searchedAirport?.length > 0 ? (
              searchedAirport?.map((airport) => (
                <div
                  key={airport?.id}
                  className="search-airport-dialog-list-item"
                  onClick={() => handleSelectAirport(airport)}
                >
                  {airport?.name}
                </div>
              ))
            ) : (
              <div className="search-airport-dialog-no-results">
                {searchText.length > 2 ? 'No results found' : 'Start typing to search...'}
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SearchAirportDialog;
